import React, { useState, useEffect, useRef } from "react";
import ReactQuill from "../ui/RichText";
import Button from "./Button";
import StatusSection from "./Projects/StatusSection";

function SelectedTask({
    active,
    activeProjectId,
    statuses,
    Plus,
    newStatusWrapperRef,
    Input,
    newStatusName,
    setNewStatusName,
    MoveLeft,
    selectedProjectData,
    setActiveProjectId,
    setActiveSubProjectId,
    activeSubProjectId,
    Info,
    useLoginDetials,
    Pencil,
    X,
    projects,
    addStatus,
    taskOrder,
    sensors,
    handleDragEnd,
    toggleTaskSelection,
    selectedTasks,
    employees,
    currentUser,
    updateProject,
    setToastMessage,
    setToastType,
    setCurrentTask,
    setRunningTaskId,
    setEditData,
    setShowDescriptionPopup,
    setSelectedTasks,
    isBelow1280,
    collapsedStatuses,
    toggleStatus,
    activeProject,
    activeSubProjectObj,
    statusRef,
    setStatuses,
    setTaskOrder,
    formatStatusLabel,
    renameStatusMutation,
    tasksByStatus,
    setOpenMenuStatus,
    openMenuStatus,
    menuRef,
    deleteStatusMutation,
    addTaskRef,
    CircleCheck,
    showDatePicker,
    setShowDatePicker,
    localProjects,
    dragDropTaskMutation,
    nowIST,
    ProjectCalender,
    getStatusColor,
    TeamDetialis,
    refetch
}) {
    const showBackButton =
        active === "list" &&
        activeProjectId &&
        (!selectedProjectData?.isMultiProject || activeSubProjectId);

    const handleBackClick = () => {
        if (activeSubProjectId && activeSubProjectId !== activeProjectId) {
            setActiveSubProjectId(null);
        } else {
            setActiveProjectId(null);
            setActiveSubProjectId(null);
        }
    };

    const [loginDetials, setLoginDetials] = useState(
        selectedProjectData?.loginDetials || ""
    );
    const [showCalendar, setShowCalendar] = useState(false);
    const [showTeam, setShowTeam] = useState(false);

    const { mutate: updateLoginDetials, isPending } = useLoginDetials();
    const textareaRef = useRef(null);

    useEffect(() => {
        if (activeSubProjectId) {
            const parentProject = projects.find(project =>
                project.subProjects?.some(sp => sp._id === activeSubProjectId)
            );
            const subProject = parentProject?.subProjects?.find(sp => sp._id === activeSubProjectId);
            setLoginDetials(subProject?.subloginDetials || "");
        } else {
            setLoginDetials(selectedProjectData?.loginDetials || "");
        }
    }, [activeSubProjectId, selectedProjectData, projects]);

    const [isEditing, setIsEditing] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const parentProject = projects.find(project =>
        project.subProjects?.some(sp => sp._id === activeSubProjectId)
    );

    const subProject = parentProject?.subProjects?.find(
        sp => sp.id === activeSubProjectId
    );

    const handleSaveLoginDetails = () => {
        let projectId = selectedProjectData?.id;
        let subProjectId = null;
        const subProject = projects
            .flatMap(p => p.subProjects || [])
            .find(sp => sp.id === activeSubProjectId);

        if (subProject) {
            projectId = subProject.projectId;
            subProjectId = subProject.id;
        }

        if (!projectId) {
            return;
        }

        updateLoginDetials(
            { projectId, loginDetials, subProjectId },
            {
                onSuccess: () => {
                    setShowModal(false);
                    setIsEditing(false);
                }
            }
        );
    };

    useEffect(() => {
        if (isEditing && textareaRef.current) {
            textareaRef.current.focus();
            textareaRef.current.selectionStart = textareaRef.current.value.length;
            textareaRef.current.selectionEnd = textareaRef.current.value.length;
        }
    }, [isEditing]);

    const canReorder = ["Admin", "Management"].includes(
        currentUser?.department
    );

    return (
        <div>
            {active === "list" && showBackButton && (
                <div className="grid gap-2 mb-4 p-2 rs:p-6 mt-10">
                    <div className="flex items-center gap-2 justify-between">
                        <div className="flex items-center gap-2">
                            <div
                                className="flex items-center gap-2 cursor-pointer back-btn"
                                onClick={handleBackClick}
                            >
                                <MoveLeft size={20} />
                                <span className="font-[400] text-gray-900">
                                    {activeSubProjectId && activeSubProjectId !== activeProjectId
                                        ? selectedProjectData?.subProjects?.find(
                                            (sp) => sp.id === activeSubProjectId
                                        )?.name || selectedProjectData?.projectName || "Untitled Project"
                                        : selectedProjectData?.projectName || "Untitled Project"}
                                </span>
                            </div>

                            <div
                                className="inline-flex items-center gap-2 bg-zinc-800 text-rose-50 text-xs font-medium px-3 py-1 rounded-full shadow-sm select-none cursor-pointer hover:bg-zinc-700"
                                onClick={() => setShowModal(true)}
                            >
                                Details <Info size={18} />
                            </div>
                        </div>

                        {canReorder && (<div className="hidden sm:flex items-center gap-2">
                            <div
                                className="cursor-pointer inline-flex items-center justify-center rounded-md font-medium transition-all px-3 py-2 sm:px-5 sm:py-2 text-xs sm:text-sm shadow hover:shadow-md bg-blue-600 text-white"
                                onClick={() => setShowCalendar(true)}
                            >
                                Calendar
                            </div>
                            <div
                                className="cursor-pointer inline-flex items-center justify-center rounded-md font-medium transition-all px-3 py-2 sm:px-5 sm:py-2 text-xs sm:text-sm shadow hover:shadow-md bg-blue-600 text-white"
                                onClick={() => setShowTeam(true)}
                            >
                                Team
                            </div>
                        </div>)}

                        {showTeam && (
                            <div
                                className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-2 sm:px-4"
                                onClick={() => setShowTeam(false)}
                            >
                                <div
                                    className="
  relative w-full 
  max-w-[80%] h-[90vh] 

  max-lg:max-w-full 
  max-lg:h-[95vh] 
  max-lg:rounded-t-2xl 
  max-lg:rounded-b-none 
  max-lg:mt-auto

  bg-white rounded-2xl shadow-2xl flex flex-col animate-scaleIn
"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <div className="flex items-center justify-between px-6 py-4 border-b bg-gray-50 rounded-t-2xl">
                                        <h3 className="text-lg font-semibold">Team Details</h3>

                                        <button
                                            onClick={() => setShowTeam(false)}
                                            className="p-2 rounded-full hover:bg-red-100"
                                        >
                                            <X size={18} className="text-red-500" />
                                        </button>
                                    </div>

                                    <div className="flex-1 overflow-auto p-4">
                                        <TeamDetialis
                                            project={projects}
                                            activeProjectId={activeProjectId}
                                            statuses={statuses}
                                            user={currentUser}
                                            activeSubProjectId={activeSubProjectId}
                                            employees={employees}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {showCalendar && (
                            <div
                                className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-2 sm:px-4"
                                onClick={() => setShowCalendar(false)}
                            >
                                <div
                                    className="
  relative w-full 
  max-w-[80%] h-[90vh] 

  max-lg:max-w-full 
  max-lg:h-[95vh] 
  max-lg:rounded-t-2xl 
  max-lg:rounded-b-none 
  max-lg:mt-auto

  bg-white rounded-2xl shadow-2xl flex flex-col animate-scaleIn
"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <div className="flex items-center justify-between px-6 py-4 border-b bg-gray-50 rounded-t-2xl">
                                        <h3 className="text-lg font-semibold">Project Calendar</h3>

                                        <button
                                            onClick={() => setShowCalendar(false)}
                                            className="p-2 rounded-full hover:bg-red-100"
                                        >
                                            <X size={18} className="text-red-500" />
                                        </button>
                                    </div>

                                    <div className="flex-1 overflow-auto p-4">
                                        <ProjectCalender
                                            project={projects}
                                            activeProjectId={activeProjectId}
                                            getStatusColor={getStatusColor}
                                            activeSubProjectId={activeSubProjectId}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {showModal && (
                        <div
                            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-2 sm:px-4"
                            onClick={() => {
                                setShowModal(false);
                                setIsEditing(false);
                            }}
                        >
                            <div
                                className="
        relative w-full max-w-3xl
        h-[60vh] sm:h-[75vh]
        bg-white rounded-xl sm:rounded-2xl
        shadow-2xl flex flex-col
        animate-scaleIn
      "
                                onClick={(e) => e.stopPropagation()}
                            >
                                {/* Header */}
                                <div
                                    className="
          flex items-center justify-between
          px-3 py-2 sm:px-6 sm:py-4
          border-b bg-gray-50
          rounded-t-xl sm:rounded-t-2xl
        "
                                >
                                    <h3
                                        className="
            text-base sm:text-xl
            font-semibold text-gray-800
          "
                                    >
                                        Project Details
                                    </h3>

                                    <button
                                        onClick={() => {
                                            setShowModal(false);
                                            setIsEditing(false);
                                        }}
                                        className="p-1.5 sm:p-2 rounded-full hover:bg-red-100 transition"
                                    >
                                        <X size={16} className="sm:w-[18px] sm:h-[18px] text-red-500" />
                                    </button>
                                </div>

                                {/* Body */}
                                <div
                                    className="
          flex-1
          p-3 sm:p-6
          overflow-y-auto
          relative bg-white
        "
                                >
                                    {isEditing ? (
                                        <ReactQuill
                                            value={loginDetials}
                                            onChange={setLoginDetials}
                                            theme="snow"
                                            placeholder="Enter login details..."
                                            className="
              h-full
              min-h-[250px] sm:min-h-[350px]
              rounded-lg sm:rounded-xl
              border border-gray-300
              text-xs sm:sm
            "
                                        />
                                    ) : (
                                        <div
                                            className="
              h-full
              min-h-[250px] sm:min-h-[350px]
              rounded-lg sm:rounded-xl
              border border-gray-200
              p-3 sm:p-5
              bg-gray-50
              text-gray-700
              text-[12px] sm:sm
              leading-relaxed
              overflow-auto
              ql-editor
            "
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    loginDetials ||
                                                    "<p class='text-gray-400'>No login details</p>",
                                            }}
                                        />
                                    )}

                                    {!isEditing && (
                                        <button
                                            onClick={() => setIsEditing(true)}
                                            className="
              absolute top-3 right-3 sm:top-6 sm:right-6
              p-1.5 sm:p-2
              rounded-lg
              bg-blue-50 hover:bg-blue-100
              transition
            "
                                        >
                                            <Pencil
                                                size={14}
                                                className="sm:w-[16px] sm:h-[16px] text-blue-600"
                                            />
                                        </button>
                                    )}
                                </div>

                                {/* Footer */}
                                {isEditing && (
                                    <div
                                        className="
            flex justify-end gap-2 sm:gap-3
            px-3 py-2 sm:px-6 sm:py-4
            border-t bg-gray-50
            rounded-b-xl sm:rounded-b-2xl
          "
                                    >
                                        <Button
                                            onClick={() => setIsEditing(false)}
                                            variant="danger"
                                        >
                                            Cancel
                                        </Button>

                                        <Button
                                            onClick={handleSaveLoginDetails}
                                            disabled={isPending}
                                            variant="success"
                                            className="flex items-center justify-center gap-2"
                                        >
                                            {isPending ? (
                                                <>
                                                    Saving...
                                                    <span className="loader-circle"></span>
                                                </>
                                            ) : (
                                                "Save Changes"
                                            )}
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            )}

            <div className="m-2 rs:m-6">
                {activeProjectId && statuses.length > 0 && (
                    <div className="border border-gray-300 rounded-lg p-2 sm:p-4 bg-white shadow-sm ">
                        {statuses.map((status) => (
                            <StatusSection
                                key={status}
                                status={status}
                                tasks={tasksByStatus?.[status] || []}
                                taskOrder={taskOrder}
                                sensors={sensors}
                                handleDragEnd={handleDragEnd}
                                toggleTaskSelection={toggleTaskSelection}
                                selectedTasks={selectedTasks}
                                activeProjectId={activeProjectId}
                                activeProject={activeProject}
                                activeSubProjectObj={activeSubProjectObj}
                                employees={employees}
                                currentUser={currentUser}
                                updateProject={updateProject}
                                setToastMessage={setToastMessage}
                                setToastType={setToastType}
                                setCurrentTask={setCurrentTask}
                                setRunningTaskId={setRunningTaskId}
                                setEditData={setEditData}
                                setShowDescriptionPopup={setShowDescriptionPopup}
                                setSelectedTasks={setSelectedTasks}
                                isBelow1280={isBelow1280}
                                collapsedStatuses={collapsedStatuses}
                                toggleStatus={toggleStatus}
                                statuses={statuses}
                                statusRef={statusRef}
                                setStatuses={setStatuses}
                                setTaskOrder={setTaskOrder}
                                projects={projects}
                                activeSubProjectId={activeSubProjectId}
                                renameStatusMutation={renameStatusMutation}
                                formatStatusLabel={formatStatusLabel}
                                tasksByStatus={tasksByStatus}
                                setOpenMenuStatus={setOpenMenuStatus}
                                openMenuStatus={openMenuStatus}
                                menuRef={menuRef}
                                deleteStatusMutation={deleteStatusMutation}
                                addTaskRef={addTaskRef}
                                CircleCheck={CircleCheck}
                                showDatePicker={showDatePicker}
                                setShowDatePicker={setShowDatePicker}
                                localProjects={localProjects}
                                dragDropTaskMutation={dragDropTaskMutation}
                                nowIST={nowIST}
                                refetch={refetch}
                            />
                        ))}
                    </div>
                )}

                {activeProjectId && statuses.length > 0 && (
                    <div className="status-input w-[100%] sm:w-[50%] p-2 mt-6 flex items-center gap-2 border border-gray-300 bg-white pl-3 rounded-lg shadow-sm hover:border-gray-400 transition-all">
                        <Plus size={16} color="#6B7280" />
                        <div className="w-full" ref={newStatusWrapperRef}>
                            <Input
                                value={newStatusName}
                                onChange={(e) => setNewStatusName(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        addStatus();
                                    }
                                }}
                                placeholder="Add new status (e.g. Review)"
                                className="w-full p-1 border-0 outline-none focus:ring-2 focus:ring-blue-400 rounded transition-all"
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
export default React.memo(SelectedTask);